import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  // NOTE: We intentionally do NOT check isLoading here.
  //
  // The authStore is persisted in localStorage and rehydrates almost instantly
  // (< 10ms). The isLoading field in the store is always false and never
  // transitions to true (login/refresh happen imperceptibly).
  //
  // Checking isLoading here would cause a flash during the brief window where
  // isAuthenticated=false (before persist rehydration) even though a valid
  // session exists in localStorage. Removing this check eliminates the flash.
  //
  // The component re-renders once when persist restores isAuthenticated=true
  // from localStorage, with no visible loading screen.

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
